import React, { useEffect, useState, useRef } from "react";
import { message, notification } from 'antd';
import { Base64 } from "js-base64";
import dayjs from 'dayjs';
import { DescriptionText, FlexContainer, H1Text, H2Text, Hr, LeftBackButtonText, Spinner } from "../../../design";
import TransactionModal from "../../../components/modal/transaction";
import SuccessModal from "../../../components/modal/success";
import { findPaymentPageLinkById,
  paymentPageChargeById,
  BASE_URLS,
  getCheckoutReconnection,
  getQrPaymentReconnection,
  paymentPageSplitUp,
  getHealthCheck,
  getSecretValuesById,
  getServerEncription,
  generateClientKeyPair,
  encryptData,
  getPayPalClientToken,
  getMrn,
  action,
  getWalletOrderInfo,
  confirmWalletOrderInfo,
} from "../../../api";
import { MESSAGES, SWIREPAY_URL, TabNames, NETBANKING_LIST, QR_STATUSES, TANGEDCO_PG, SESSION_TIME, LPG_CUSTOMER } from "../../../appconstants";
import { AmountDivideByHundred } from "../../../helper";
import BaseSplitPage from "../../../components/splitpage";
import getRedirectionUrl from "../../../utils/getRedirectionUrl";
import currencyFormatter from "../../../utils/currencyformatter";
import CardPayment from "../../../components/cardpayment/CardPayment";
import Support from "../../../components/support";
import SmallScreenHeader from "../../../components/smallscreen/header";
import DataAlertModal from "../components/DataAlert";
import getMenuTabs from "../../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../../utils/getUniquePaymentTypes";
import UpiPayment from "../../../components/upipayment/UpiPayment";
import AchPayment from "../../../components/achPaymentWithPlaid";
import InstantPayment from "../../../components/instantpayment/InstantPayment";
import BankPayment from "../../../components/bankpayment/BankPayment";
import NetBanking from "../../../components/netbanking/NetBanking";
import ApplePay from "../../../components/applePay/ApplePay";
import GooglePay from "../../../components/googlePay/GooglePay";
import PayPalCheckout from "../../paypalCheckout";
import PaymentExpandableRows from "../../../components/paymentExpandableRows";
import PaymentExpandableRowsV2 from "../../../components/PaymentExpandableRowsV2";
import Apple from '../../apple';
import { useDispatch, useSelector } from "react-redux";
import { setUpdateStatus } from "../../../redux/customerDetailsInfo";
import RecaptchaModal from "../../../components/recaptcha";
import ApplePayButton from '../../../routes/apple/PayPalApplePay';
import PayPalGooglePay from "../../../components/payPalGooglePay";
import { setFormData } from "../../../redux/appConfigInfo";
import { getCountryCodeAndNumber } from "../../../utils/getCountryCodeAndNumber";
import SavedPaymentMethods from "../../../components/SavedPaymentMethods";

type Props = {
  history: {
    push: Function,
  },
}

const PaymentPagePay = (props: Props) => {

  const { match: { params: { id } }, location: { pathname, search } } = props;
  const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
  const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
  const [isDataAlertModalOpen, setDataAlertModalOpen] = useState(false);
  const [paymentPageMeta, setPaymentPageMeta] = useState(null);
  const [paymentPageEntries, setPaymentPageEntries] = useState(null);
  const [errorMessage, setErrorMessage] = useState();
  const [isShowSpinner, setShowSpinner] = useState(false);
  const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
  const [submitBtnText, setSubmitBtnText] = useState(null);
  const [submitBtnTextAch, setSubmitBtnTextAch] = useState(null);
  const [amount, setAmount] = useState(0);
  const [currency, setCurrency] = useState(null);
  const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
  const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
  const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${id}-tap-index`) || 0));
  const [tabName, setTabName] = useState('');
  const [banksList, setBanksList] = useState(null);
  const [isTest, setIsTest] = useState(null);
  const [bankTypes, supportedBankTypes] = useState([null]);
  const [account, setAccount] = useState(null);
  const [processStatus, setProcessStatus] = useState(false);
  const [paymentPageFields, setPaymentPageFields] = useState(JSON.parse(localStorage.getItem('customerFields')));
  const tipValue = localStorage.getItem('tipValue');
  const tip = tipValue ? Number(AmountDivideByHundred(tipValue)) : null;
  const [serviceFee, setServiceFee] = useState(false);
  const [serviceFeeRate, setServiceFeeRate] = useState(false);
  const [serviceFeeVal, setServiceFeeVal] = useState(null);
  const [serviceFeeRateVal, setServiceFeeRateVal] = useState(null);
  const [finalAmount, SetFinalAmount] = useState(null);
  const [taxValue, setTaxValue] = useState(null);
  const [taxPercentage, setTaxPercentage] = useState(null);
  const [net, setNet] = useState(null);
  const [feeService, setFeeService] = useState(null);
  const [finalTax, setFinalTax] = useState(null);
  const [totalPayable, setTotalPayable] = useState(null);
  const [totalPayableAch, setTotalPayableAch] = useState(null);
  const [caluclation, setCaluclation] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [finalTip, setFinalTip] = useState(null);
  const [subTotal, setSubTotal] = useState(null);
  const [applePayment, setApplePayment] = useState(false);
  const [ipAddress, setIpAddress] = useState('');
  const [upiDownTime, setUpiDownTime] = useState(false);
  const [isApplePay, setIsApplePay] = useState(false);
  const [gpaySecretValues, setGpaySecretValues] = useState(null);
  const [gpayError, setGpayError] = useState(null);
  const [swirepayUS, setSwirepayUS] = useState(false);
  const [googlePayUs, setGooglePayUs] = useState(false);
  const [payment, setPayment] = useState({});
  const [surcharge, setSurcharge] = useState(null);
  const [updatedCardNum, setUpdatedCardNum] = useState('');
  const [optionalCheck, setOptionalCheck] = useState(true);
  const [recaptchaModalVisible, setRecaptchaModalVisible] = useState(false);
  const [savedPaymentDetails, setSavedPaymentDetails] = useState(null);
  const [recaptchaPaymentType, setRecaptchaPaymentType] = useState(null);
  const [paymentLinkUpiGlobalRecaptcha, setPaymentLinkUpiGlobalRecaptcha] = useState(null);
  const [paymentLinkInstantPaymentGlobalRecaptcha, setPaymentLinkInstantPaymentGlobalRecaptcha] = useState(null);
  const accountGid = [
    'account-cdfe7eecff324778a88a2727177a1c8f'
  ];
  const [manualPlaidPayment, setManualPlaidPayment] = useState(false);
  const [plaidPublicToken, setPlaidPublicToken] = useState(() => localStorage.getItem(`plaidPublicToken-${id}`) || undefined);
  const updateCustomerRedux = useSelector((state) => state.customerDetailsInfo);
  const dispatch = useDispatch();
  const paramsId = id;
  const [payPalClientAuth, setPayPalClientAuth] = useState('');
  const [paypalApplePayMessageModal, setPaypalApplePayMessageModal] = useState(false);
  const isPayPalApple = useRef(false);
  const isPayPalGoogle = useRef(false);
  const [paypalApplePayRecaptcha, setPaypalApplePayRecaptcha] = useState(null);
  const [paypalGooglePayRecaptchaToken, setPaypalGooglePayRecaptchaToken] = useState(null);
  const [cardPointGooglePayToken, setCardPointGooglePayToken] = useState(null);
  const [payPalClientId, setPaypalClientId] = useState('');
  const commonRecaptchaToken = useRef(null);
  const [orderDatas, setOrderData] = useState();
  const COMP_CODE = 'CUSTOMER_DETAIL';
  const paymentSessionGidRef = useRef(null);
  const redirectUrlRef = useRef(null);
  const upiAppPsClientSecretRef = useRef(null);

  const getPayPalAccountInfo = async (id) => {
    try {
      const payPalInfo = await getPayPalClientToken(id);
      const value = Base64.decode(payPalInfo);
      const value_json = JSON.parse(value);
      setPaypalClientId(value_json?.clientId);
      setPayPalClientAuth(payPalInfo);
      return payPalInfo;
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  useEffect(() => {
    if (account?.gid) {
      getPayPalAccountInfo(account?.gid);
    }
  }, [account]);

  const hostName = (window && window.location && window.location.host);
  const getData = async () => {
    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    setIpAddress(data.ip);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if(updateCustomerRedux?.updateStatus && updateCustomerRedux?.customerDetails){
        if (updateCustomerRedux?.customerDetails?.name  && updateCustomerRedux?.customerDetails?.name !== '') {
          if(paymentPageMeta?.name) {
            setPaymentPageMeta((prev) => ({...prev, name: updateCustomerRedux.customerDetails.name }));
          } else {
            setPaymentPageFields((prev) => ({...prev, name: updateCustomerRedux.customerDetails.name }));
          }
        };
        if (updateCustomerRedux?.customerDetails?.email  && updateCustomerRedux?.customerDetails?.email !== '') {
            if(paymentPageMeta?.email) {
              setPaymentPageMeta((prev) => ({...prev, email: updateCustomerRedux.customerDetails.email }));
            } else {
              setPaymentPageFields((prev) => ({...prev, email: updateCustomerRedux.customerDetails.email }));
            }
        };
        if (updateCustomerRedux?.customerDetails?.phoneNumber && updateCustomerRedux?.customerDetails?.phoneNumber !== 'undefined'
            && updateCustomerRedux?.customerDetails?.phoneNumber !== '+1'){
            if(paymentPageMeta?.phoneNumber) {
              setPaymentPageMeta((prev) => ({...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
            } else {
              setPaymentPageFields((prev) => ({...prev, phoneNumber: updateCustomerRedux.customerDetails.phoneNumber }));
            }
        };
        dispatch(setUpdateStatus(false));
    };
  }, [updateCustomerRedux]);

  useEffect(() => {
    if (search) {
      getPaymentPageLinkDataWithSearchValue();
    } else {
      getPaymentLinkDataWithoutSearchValue();
    }
    setBackButtonUrl(`/payment-page-link/${id}`);
  }, [id, search]);

  useEffect(() => {
    document.body.style.backgroundImage = ''
  }, []);

  useState(() => {
    if (window.ApplePaySession) {
      setIsApplePay(true);
    }
  }, []);

  useEffect(() => {
    if (currency && currency.name !== 'INR') { setSelectedTab(0) }
  }, [selectedTab]);

  const getCurrentTab = (tabName) => {
    const entries = JSON.parse(localStorage.getItem(id));
    const { paymentPageEntries } = entries;
    const metaGid = entries?.paymentPageLink?.paymentPageMeta?.gid;
    getSplitUp(metaGid, paymentPageEntries, tabName, '');
  };

  useEffect(() => {
    if (paymentPageEntries) {
      let totalAmount = 0;
      const entries = JSON.parse(localStorage.getItem(id));
      const { paymentPageEntries } = entries;
      const metaGid = entries.paymentPageLink.paymentPageMeta.gid;
      if (!loading) {
        getSplitUp(metaGid, paymentPageEntries, localStorage.getItem(`${id}-tab-name`) ? localStorage.getItem(`${id}-tab-name`) : 0, '');
      }
      if (entries.totalAmount) {
        totalAmount = entries.totalAmount;
      }
      const paymentPageMetaFieldTypes = ["PRICE_AMOUNT_FIXED", "PRICE_AMOUNT_CUSTOMER_DECIDED", "PRICE_AMOUNT_QUANTITY_BASED"];
      const localPaymentPageMeta = paymentPageMeta && paymentPageMeta.paymentPageMetaFields.find(value => {
        return value && paymentPageMetaFieldTypes.includes(value.type) && value.currency;
      });
      const localCurrency = localPaymentPageMeta && localPaymentPageMeta.currency;
      setCurrency(localCurrency);
      const feeRateService = (AmountDivideByHundred(totalAmount) * AmountDivideByHundred(serviceFeeRate)) / 100;
      const tipValue = tip ? ((AmountDivideByHundred(totalAmount) * (tip / 100))) : 0;
      const taxValue = taxPercentage ? ((AmountDivideByHundred(totalAmount) * AmountDivideByHundred(taxPercentage)) / 100) : 0;
      const taxVal = feeRateService + tipValue + (serviceFee / 100) + taxValue;
      setTaxValue(taxVal);
      setSubmitBtnText(`PAY ${localCurrency && localCurrency.prefix} ${totalPayable ? AmountDivideByHundred(totalPayable) : '0.00'}`);
      setSubmitBtnTextAch(`PAY ${localCurrency && localCurrency.prefix} ${(totalPayable - feeService) ? AmountDivideByHundred((totalPayable - feeService)) : '0.00'}`);
      setTotalPayableAch((totalPayable - feeService));
      setServiceFeeRateVal((AmountDivideByHundred(totalAmount) * AmountDivideByHundred(serviceFeeRate)) / 100);
      setServiceFeeVal(AmountDivideByHundred(serviceFee));
      setAmount(totalPayable / 100);
      SetFinalAmount(`${localCurrency && localCurrency.prefix} ${totalPayable || 0}`)
    }
    localStorage.removeItem('updatedForm');
    window.addEventListener("storage", (function (e) {
      if (e.key === id) {
        localStorage.removeItem(id);
        localStorage.removeItem('tipValue');
      }
      getPaymentLinkDataWithoutSearchValue();
    }).bind(this));
  }, [paymentPageEntries, caluclation]);

  const getGooglePayMerchantValues = async (accountGid) => {
    try {
        const values = await getSecretValuesById(accountGid, null);
        setGpaySecretValues(values);
    } catch (error) {
        setGpayError('Missing merchant details. Please contact support')
    }
};

  const paymentPageChargeCard = async (data) => {
    const { customer, paymentMethod, notify } = data;
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
      ip: ipAddress,
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(),
      browserUserAgent: window.navigator.userAgent
     };
     paymentMethod.userAgent = userAgent;
    await chargeById({
      paymentPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      customerDetails: customer, paymentMethodDetails: paymentMethod,
      paymentPageEntries, paymentMethodType: ['CARD']
    })
  };

  const paymentPageChargeByUPI = async (data) => {
    const { customer, paymentMethod, notify } = data;
    const userAgent = {
      acceptHeaders: "Accept: text/html, application/xhtml+xml, application/xml;q=0.9, image/webp, */*;q=0.8",
      ip: ipAddress,
      language: window.navigator.language,
      colorDepth: window.screen.colorDepth,
      screenHeight: window.screen.height,
      screenWidth: window.screen.width,
      timeZone: new Date().getTimezoneOffset(),
      browserUserAgent: window.navigator.userAgent
    };
    paymentMethod.userAgent = userAgent;
    await chargeById({
      paymentPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      customerDetails: customer, paymentMethodDetails: paymentMethod,
      paymentPageEntries, paymentMethodType: ['UPI']
    });
  };


  const chargeByApple = async (paymentData, recaptchaToken = null) => {
    const {
      deviceData,
      // amount,
      customerName,
      customerEmail,
      customerPhone,
      countryCode,
      stateCode,
      street,
      postalCode,
      city,
      cardNetwork,
      cardType,
      cardLast4,
    } = paymentData;
    const billingAddress = {
      city: city,
      countryCode: countryCode,
      state: stateCode,
      street: street
    };
    setRecaptchaPaymentType('paypalApplePay');

    const paymentMethod = {
      applePayUS: {
        deviceData: deviceData,
        cardBrand: cardNetwork,
        cardFundingType: cardType,
        applePayDynamicLast4: cardLast4,
        paymentPageMetaGid: paymentPageMeta.gid,
        paymentMethodType: [''],
        cardLast4: cardLast4
      },
      type: "WALLET",
      subType: "APPLE_PAY_US",
      postalCode: postalCode,
      paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
    }
    const customer = {
      email: paymentPageFields?.contactUsEmail ? paymentPageFields?.contactUsEmail : (customerEmail ? customerEmail : ''),
      name: paymentPageFields?.name ? paymentPageFields?.name : (customerName ? customerName : '----'),
      phoneNumber: paymentPageFields?.contactUsPhone ? paymentPageFields?.contactUsPhone : (customerPhone ? customerPhone : '')
    }
    const value = await getPayPalAccountInfo(account?.gid);
    if (value) {
      isPayPalApple.current = true;
    }
    const responseEntity = await chargeById({
      paymentMethod: paymentMethod,
      paymentPageEntries,
      customerGid: account.gid,
      customerDetails: customer,
      paymentMethodDetails: paymentMethod,
      paymentPageMetaGid: paymentPageMeta.gid,
      paymentMethodType: [
        "WALLET"
      ],
    }, recaptchaToken);
    isPayPalApple.current = false;
    return responseEntity;
  }

  const chargeByCardpointeApplePay = async (paymentData) => {
    const {
      deviceData,
      // amount,
      customerName,
      customerEmail,
      customerPhone,
      countryCode,
      stateCode,
      street,
      postalCode,
      city,
      cardNetwork,
      cardType,
      cardLast4,
    } = paymentData;
  
    const billingAddress = {
      city: city,
      countryCode: countryCode,
      state: stateCode,
      street: street
    };

    const paymentMethod = {
      applePayUS: {
        deviceData: deviceData,
        cardBrand: cardNetwork,
        cardFundingType: cardType,
        applePayDynamicLast4: cardLast4,
        cardLast4: cardLast4
      },
      type: "WALLET",
      subType: "APPLE_PAY_US",
      postalCode: postalCode,
      paymentMethodBillingAddress: (city && street && stateCode) ? billingAddress : null,
    }

    let customer = {
      email: customerEmail,
      name: customerName,
      phoneNumber: customerPhone,
    }

    await chargeById({
      paymentMethod: paymentMethod,
      paymentPageEntries,
      customerGid: account.gid,
      customerDetails: customer,
      paymentMethodDetails: paymentMethod,
      paymentPageMetaGid: paymentPageMeta.gid,
      paymentMethodType: [
        "WALLET"
      ],
    }, null);
  };

const getCustomerGidFromPayment = () => {
  return paymentPageMeta  && paymentPageMeta.gid;
};
  const paymentPageChargeByACH = async (data) => {
    const { customer, paymentMethod, notify } = data;
    await chargeById({
      paymentPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      customerDetails: customer, paymentMethodDetails: paymentMethod,
      paymentPageEntries, paymentMethodType: ['ACH_LEGACY'],
      skipServiceFee: true
    });
  };

  const chargeBySavedPaymentMethods = async (data) => {
    await chargeById({
      paymentMethodDetails: data,
      paymentPageMetaGid: paymentPageMeta.gid,
      paymentPageEntries,
      customerDetails: {
        name: updateCustomerRedux?.customerDetails?.name,
        email: updateCustomerRedux?.customerDetails?.email,
        phoneNumber: updateCustomerRedux?.customerDetails?.phoneNumber,
      }
    });
  };

  const chargeByInstantPay = async (data) => {
    const { customer, walletAlias, notify } = data;
    const paymentMethod = {
      type: "INSTANT_PAYMENT",
      instantPayment: {
        alias: walletAlias,
        type: "ALIAS",
      },
    };
    await chargeById({
      paymentMethodDetails: paymentMethod,
      paymentPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      paymentPageEntries,
      customerDetails: customer,
      paymentMethodType: ['INSTANT_PAYMENT']
    });
  };

  const chargeBySwirepayUS = async (data) => {
    const { walletAlias, notify } = data;
    const paymentMethod = {
      type: "WALLET",
      subType: "SWIREPAY_US",
      swirepayUS: {
        alias: walletAlias,
        type: "ALIAS",
      },
    };
    await chargeById({
      paymentMethodDetails: paymentMethod,
      paymentPageMetaGid: paymentPageMeta.gid,
      shouldWhatsAppNotify: notify,
      paymentPageEntries,
      paymentMethodType: ['WALLET']
    });
  };

  const paymentPageChargeByBANK = async (data) => {
    const { customer, customerGid, fundingSourceId } = data;
    const paymentMethod = {
      bank: {
        referenceId: fundingSourceId,
      },
      customerGid,
      type: "ACH"
    }
    await chargeById({
      paymentPageMetaGid: paymentPageMeta.gid,
      paymentMethodDetails: paymentMethod,
      customerDetails: customer,
      paymentPageEntries, paymentMethodType: ['ACH']
    });
  };

  const chargeByApplePay = async (stripePaymentMethod, recaptchaToken = null) => {
    // const meta = stripePaymentMethod;
    const customer = {
      email: paymentPageFields?.contactUsEmail ? paymentPageFields?.contactUsEmail : (stripePaymentMethod.billing_details.email ? stripePaymentMethod.billing_details.email : ''),
      name: paymentPageFields?.name ? paymentPageFields?.name : (stripePaymentMethod.billing_details.name ? stripePaymentMethod.billing_details.name : '----'),
      phoneNumber: paymentPageFields?.contactUsPhone ? paymentPageFields?.contactUsPhone : (stripePaymentMethod.billing_details.phone ? stripePaymentMethod.billing_details.phone : ''),
    }
    const paymentMethod = {
      applePayUS: {
            stripePaymentMethodId: stripePaymentMethod.id,
            cardBrand: stripePaymentMethod.card.brand,
            cardExpMonth: stripePaymentMethod.card.exp_month,
            cardExpYear: stripePaymentMethod.card.exp_year,
            cardFundingType: stripePaymentMethod.card.funding,
            applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
            cardLast4: stripePaymentMethod.card.last4,
            billingAddress: {
              street: stripePaymentMethod.billing_details.address.line1,
              city: stripePaymentMethod.billing_details.address.city,
              state: stripePaymentMethod.billing_details.address.state,
              postalCode: stripePaymentMethod.billing_details.address.postal_code,
              countryCode: stripePaymentMethod.billing_details.address.country
            },
            name: stripePaymentMethod.billing_details.name,
            email: stripePaymentMethod.billing_details.email,
            phone: stripePaymentMethod.billing_details.phone
          },
          customerGid: account.gid,
          type: "WALLET",
          subType: "APPLE_PAY_US",
          rawData: {
            stripePaymentMethodId: stripePaymentMethod.id,
            cardBrand: stripePaymentMethod.card.brand,
            cardExpMonth: stripePaymentMethod.card.exp_month,
            cardExpYear: stripePaymentMethod.card.exp_year,
            cardFundingType: stripePaymentMethod.card.funding,
            applePayDynamicLast4: stripePaymentMethod.card.wallet.dynamic_last4,
            cardLast4: stripePaymentMethod.card.last4,
            billingAddress: {
              street: stripePaymentMethod.billing_details.address.line1,
              city: stripePaymentMethod.billing_details.address.city,
              state: stripePaymentMethod.billing_details.address.state,
              postalCode: stripePaymentMethod.billing_details.address.postal_code,
              countryCode: stripePaymentMethod.billing_details.address.country
            },
            name: stripePaymentMethod.billing_details.name,
            email: stripePaymentMethod.billing_details.email,
            phone: stripePaymentMethod.billing_details.phone
          }
        };
    const value = await getPayPalAccountInfo(payment?.account?.gid);
    if (value) {
      isPayPalApple.current = true;
    }
    const responseEntity = await chargeById({
      paymentMethod: paymentMethod,
      paymentPageEntries,
      customerGid: account.gid,
      customerDetails: customer,
      paymentMethodDetails: paymentMethod,
      paymentPageMetaGid: paymentPageMeta.gid,
      paymentMethodType: [
        "WALLET"
      ]
    }, recaptchaToken);
    isPayPalApple.current = false;
    return responseEntity;
};

  const chargeByPaypalGooglePay = async (data) => {
    try {
      setRecaptchaPaymentType('paypalGooglePay');
      const value = await getPayPalAccountInfo(payment?.account?.gid);
      if (value) {
        isPayPalGoogle.current = true;
        data.email = paymentPageFields?.contactUsEmail;
        const customer = {
          email: paymentPageFields?.contactUsEmail ? paymentPageFields?.contactUsEmail : '',
          name: paymentPageFields?.name ? paymentPageFields?.name : '----',
          phoneNumber: paymentPageFields?.contactUsPhone ? paymentPageFields?.contactUsPhone : ''
        }
        const paymentMethod = {
          type: "WALLET",
          subType: "GOOGLE_PAY_US",
          googlePayUS: {
            apiVersionMinor: data.apiVersionMinor,
            apiVersion: data.apiVersion,
            paymentMethodDescription: data.paymentMethodData.description,
            paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
            paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
            paymentMethodType: data.paymentMethodData.type,
            paymentMethodInfo: data.paymentMethodData.info
          },
        };
        const responseEntity = await chargeById({
          paymentMethodDetails: paymentMethod,
          customerGid: account.gid,
          customerDetails: customer,
          paymentPageEntries,
          paymentMethod: paymentMethod,
          paymentMethodType: ['WALLET'],
          paymentPageMetaGid: paymentPageMeta?.gid,
        }, paypalGooglePayRecaptchaToken);
        isPayPalGoogle.current = false;
        const orderId = await getMrn(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
        // Step 2: confirm PayPal order
        await window.paypal.Googlepay().confirmOrder({
          orderId,
          paymentMethodData: data?.paymentMethodData,
        });
        // Step 3: capture/perform final action
        await action(responseEntity.paymentSessionGid, responseEntity.psClientSecret);
        chargeByIdSuccessActions(responseEntity);
      }
    } catch (err) {
      console.error('Google Pay Failed', err);
      message.error('GooglePay Transaction Failed');
      chargeByIdFailActions();
    }
  };

  const chargeByGooglePay = async (data) => {
    data.email = paymentPageFields?.contactUsEmail;
    const customer = {
      email: paymentPageFields?.contactUsEmail ? paymentPageFields?.contactUsEmail : '',
      name: paymentPageFields?.name ? paymentPageFields?.name : '----',
      phoneNumber: paymentPageFields?.contactUsPhone ? paymentPageFields?.contactUsPhone : ''
    }
    const paymentMethod = {
        type: "WALLET",
        subType: "GOOGLE_PAY_US",
        googlePayUS: {
            apiVersionMinor: data.apiVersionMinor,
            apiVersion: data.apiVersion,
            paymentMethodDescription: data.paymentMethodData.description,
            paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
            paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
            paymentMethodType: data.paymentMethodData.type,
            paymentMethodInfo: data.paymentMethodData.info
        },
    };
    setRecaptchaPaymentType('cardPointGooglePay');
    await chargeById({
      paymentMethodDetails: paymentMethod,
      customerGid: account.gid,
      customerDetails: customer,
      paymentPageEntries,
      paymentMethod: paymentMethod,
      paymentMethodType: ['WALLET'],
      paymentPageMetaGid: paymentPageMeta?.gid,
    }, cardPointGooglePayToken);
  };

  const chargeByNetBanking = async (data) => {
    const { customer, gid, notify } = data;
    const paymentMethod = {
      type: "NET_BANKING",
      netbanking: {
        swirepayBankGid: gid,
      },
    };
    await chargeById({
      paymentPageMetaGid: paymentPageMeta.gid,
      customerDetails: customer,
      shouldWhatsAppNotify: notify,
      paymentMethodDetails: paymentMethod,
      paymentPageEntries,
      paymentMethodType: ['NET_BANKING'],
    });
  };

  const updateSurcharge = (val) => {
    const entries = JSON.parse(localStorage.getItem(id));
    const { paymentPageEntries } = entries;
    const metaGid = entries?.paymentPageLink?.paymentPageMeta?.gid;
    getSplitUp(metaGid, paymentPageEntries, localStorage.getItem(`${id}-tab-name`) ? localStorage.getItem(`${id}-tab-name`) : 0, updatedCardNum, val);
  }

  const getCardNum = (cardNum) => {
    setUpdatedCardNum(cardNum);
    const entries = JSON.parse(localStorage.getItem(id));
    const { paymentPageEntries } = entries;
    const metaGid = entries?.paymentPageLink?.paymentPageMeta?.gid;
    getSplitUp(metaGid, paymentPageEntries, localStorage.getItem(`${id}-tab-name`) ? localStorage.getItem(`${id}-tab-name`) : 0, cardNum);
  }

  const getSplitUp = async (metaGid, payload, tabName, cardNum, val) => {
    const dataPayload = payload.filter((item) => item.type !== 'CUSTOM_FORM');
    const params = {
      paymentPageEntries: dataPayload,
      paymentType: (tabName !== 'CARD' && !cardNum) ? tabName : (cardNum ? 'CARD' : ''),
      cardNumber: tabName === 'CARD' ? cardNum : '',
      surchargeApplicable: (payment?.paymentPageMeta?.surchargeEnabled && account?.surchargeType && account?.surchargeType !== 'NONE') ? true : false,
    };
    if (val === true ||  val === false) {
      setOptionalCheck(val)
      params.surchargeApplicable = val;
    }

    try {
      const value = await paymentPageSplitUp(metaGid, params);
      setNet(value.net);
      setFeeService(value.serviceFee);
      setFinalTax(value.tax);
      setTotalPayable(value.totalPayable);
      setCaluclation(value);
      setFinalTip(value.tip);
      setDiscount(value.discountedAmount);
      setSubTotal(value.subTotal);
      setSurcharge(value.surcharge);
    } catch (reason) {
      error(reason);
    }
    setLoading(true);
  }

  const chargeByIdFailActions = async () => {
    setTransactionModalOpen(false);
  };

  const chargeByIdSuccessActions = async (value) => {
    const { nextActionUrl, redirectUri, paymentStatus } = value;
    if (paymentStatus && paymentStatus === 'PROCESSING') {
      setProcessStatus(true);
    }
    if (paymentStatus && paymentStatus === 'REQUIRE_CONFIRMATION') {
      setManualPlaidPayment(true);
    }
    if (nextActionUrl) {
      window.location = nextActionUrl;
      return;
    }
    if (redirectUri) {
      window.location = redirectUri;
      return;
    }
    setTransactionModalOpen(false);
    setTransactionSuccessModalOpen(true);
    const timeOut = value?.paymentStatus === 'REQUIRE_CONFIRMATION' ? 10000 : 5000;
    setTimeout(function () {
      if (!(account?.gid === 'account-c0adbb4137dc4d6c9a9df98cb29bf401' && id === 'paymentpagelink-b4b57686aabf4f5fa8d7ae02d866741b')) {
        window.location = id ? `/payment-page-link/${id}` : SWIREPAY_URL;
      }
    }, timeOut);
    sessionStorage.removeItem("stripeRes");
    if (id) { localStorage.removeItem(id); localStorage.removeItem(`${id}-tap-index`); localStorage.removeItem(`${id}-tab-name`) }
  };

    const chargeByUpiIndent = async (data, recaptchaToken = null) => {
    const payaloadData = {
      paymentPageMetaGid: paymentPageMeta.gid,
      paymentMethodDetails: data?.paymentMethod,
      paymentPageEntries,
      customerDetails: data?.customer,
      paymentMethodType: ['UPI']
    }
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          const encriptedData = encryptData(JSON.stringify(payaloadData), values.public_key, keys.privateKey, values.key_id);
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            const value = await paymentPageChargeById(id, payload);
            if (value) {
              const { nextActionUrl, redirectUri } = value;
              paymentSessionGidRef.current = value?.paymentSessionGid;
              upiAppPsClientSecretRef.current = value?.psClientSecret;
              redirectUrlRef.current = redirectUri;
              return (nextActionUrl || null);
            }
          }
        }
      }
      return null;
    } catch (reason) {
      if (reason?.status === 429) {
        setRecaptchaPaymentType('upi_indent');
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      
      error(reason);
    }
  };

  const handleRedirect = () => {
    if (redirectUrlRef?.current) {
      window.location = redirectUrlRef?.current;
      return;
    }
    if (!(account?.gid === 'account-c0adbb4137dc4d6c9a9df98cb29bf401' && id === 'paymentpagelink-b4b57686aabf4f5fa8d7ae02d866741b')) {
      window.location = id ? `/payment-page-link/${id}` : SWIREPAY_URL;
    }
    sessionStorage.removeItem("stripeRes");
    if (id) { localStorage.removeItem(id); localStorage.removeItem(`${id}-tap-index`); localStorage.removeItem(`${id}-tab-name`) }
  };

  const onReturnFromUpiApp = async () => {
    setTransactionModalOpen(true);

    try {
      const paymentSessionId = paymentSessionGidRef?.current;
      const clientSecret = upiAppPsClientSecretRef?.current;

      if (!paymentSessionId || !clientSecret) {
        handleRedirect();
        return;
      }

      // poll to check if the transaction has processed
      let entity;
      let attempts = 0;
      const MAX_ATTEMPTS = 15; // poll every 1s for upto 15 seconds
      const POLLING_INTERVAL = 1000;
      while (attempts < MAX_ATTEMPTS) {
        entity = await action(paymentSessionId, clientSecret);
        if (entity?.status === 'REQUIRE_ACTION') {
          await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
          attempts++;
        } else {
          break;
        }
      }

      if (entity?.status === 'SUCCEEDED') {
        setTransactionSuccessModalOpen(true);

        const timeout = redirectUrlRef?.current
          ? SESSION_TIME.REDIRECT_URL
          : SESSION_TIME.NO_REDIRECT_URL;

        setTimeout(() => {
          handleRedirect();
        }, timeout);

        return;
      }

      // Failed or other status
      handleRedirect();

    } catch (error) {
      console.error("UPI return error:", error);
      handleRedirect();
    } finally {
      setTransactionModalOpen(false);
    }
  };

  const chargeById = async (data, recaptchaToken = null) => {
    data.surchargeApplicable = (account?.surchargeType === 'OPTIONAL' && payment?.paymentPageMeta?.surchargeEnabled) ? optionalCheck : (account?.surchargeType !== 'NONE' && payment?.paymentPageMeta?.surchargeEnabled) ? true : false;
    setTransactionModalOpen(true);
    try {
      const values = await getServerEncription(recaptchaToken);
      if (values?.public_key) {
        const keys = generateClientKeyPair();
        if (keys?.privateKey) {
          const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
          const payload = {
            publicKey: keys?.publicKey,
            keyId: encriptedData?.keyId,
            iv: encriptedData?.iv,
            data: encriptedData?.encryptedData,
          }
          if (encriptedData?.keyId) {
            const value = await paymentPageChargeById(id, payload);
            if (!isPayPalApple.current
              && !isPayPalGoogle.current
            ) {
              await chargeByIdSuccessActions(value);
            }
            return value;
          }
        }
      }
    } catch (reason) {
      if (reason?.status === 429){
        setSavedPaymentDetails(data);
        setRecaptchaModalVisible(true);
        setTransactionModalOpen(false);
        return;
      }
      error(reason);
    }
  };

  const onGlobalCaptchaVerified = async (token) => {
    setRecaptchaModalVisible(false);
    switch (recaptchaPaymentType) {
      case TabNames.UPI:
        setPaymentLinkUpiGlobalRecaptcha(token);
        break;
      case TabNames.INSTANT_PAYMENT:
        setPaymentLinkInstantPaymentGlobalRecaptcha(token);
        break;
      case 'paypalApplePay':
        setPaypalApplePayRecaptcha(token);
        setPaypalApplePayMessageModal(true);
        break;
      case 'paypalGooglePay':
        setPaypalGooglePayRecaptchaToken(token);
        break;
      case 'cardPointGooglePay':
        setCardPointGooglePayToken(token);
        break;
      case 'payPalButton':
        commonRecaptchaToken.current = token;
        break;
      case 'upi_indent':
        chargeByUpiIndent(savedPaymentDetails, token);
        break;
      default:
        await chargeById(savedPaymentDetails, token);
    }
    setRecaptchaPaymentType(null);
  }

  const getPaymentLinkDataWithoutSearchValue = async () => {
    setShowSpinner(true);
    const entries = JSON.parse(localStorage.getItem(id));
    if (entries && entries.paymentPageEntries) {
      await getPaymentPageLinkById();
     const modifiedData = entries.paymentPageEntries.map(obj => {
      if (obj.type === "CONSENT_FORM") {
        return { ...obj, value: "ACCEPTED" };
      }
      return obj;
    });

    // Save the filtered entries in paymentPageEntries
      setPaymentPageEntries(modifiedData)
    } else {
      setDataAlertModalOpen(true);
      setTimeout(function () {
        props.history.push(`/payment-page-link/${id}`);
        setDataAlertModalOpen(false);
      }, 5000);
      if (id) { localStorage.removeItem(id); }
    }
    setShowSpinner(false);
  };

  const getPaymentPageLinkById = async () => {
    try {
      const value = await findPaymentPageLinkById(id);
      if (value) {
        if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
        //   const val = await getHealthCheck();
        //   if (val && val.status !== 'ACTIVE') {
        //     setUpiDownTime(true);
        //     notification.open({
        //         message: '',
        //         description: <img src={UPIIMAGE} alt="" />,
        //       });
        // }
        }
        setPayment(value);
        setPaymentPageMeta(value.paymentPageMeta);
        dispatch(setFormData({ code: COMP_CODE,
          value: {
              phoneNumber: paymentPageFields?.contactUsPhone ? getCountryCodeAndNumber(paymentPageFields?.contactUsPhone)?.phoneNumber : '',
              countryCode: paymentPageFields?.contactUsPhone ? getCountryCodeAndNumber(paymentPageFields?.contactUsPhone)?.countryCode : '+1',
              name: paymentPageFields?.name,
              email: paymentPageFields?.contactUsEmail,
              disablePhone: paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone,
          } 
        }));
        setAccount(value.account);
        setServiceFee(value.paymentPageMeta && value.paymentPageMeta.serviceFee);
        setServiceFeeRate(value.paymentPageMeta && value.paymentPageMeta.serviceFeeRate);
        setTaxPercentage(value.paymentPageMeta && value.paymentPageMeta.taxPercentage);
        if (value && value.account && value.account.gid) {
          setApplePayment(value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes.includes('APPLE_PAY_US'));
          setSwirepayUS(value && value.account && value.account.supportedPaymentTypes.includes('SWIREPAY_US'));
          setGooglePayUs(value && value.account && value.account.supportedPaymentTypes.includes('GOOGLE_PAY_US'));
          if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('GOOGLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
            getGooglePayMerchantValues(value && value.account && value.account.gid);
        }
        if ((value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('APPLE_PAY_US') || (value && value.account && value.account.supportedPaymentTypes && value.account.supportedPaymentTypes).includes('WALLET')) {
            getGooglePayMerchantValues(value && value.account && value.account.gid);
        }
          if (TANGEDCO_PG === value.account.gid) {
            if (value.account.paymentTypeOrder) {
              setPaymentTypeOrder([{ category: 'CARD' }]);
            } else setSupportedPaymentTypes(['CARD']);
          } else if (TANGEDCO_PG !== value.account.gid) {
            if (value.account.paymentTypeOrder) {
              const paymentMethod = getUniquePaymentTypes(value.account && value.account.supportedPaymentTypes);
              const paymentOrders = value && value.account && value.account.paymentTypeOrder;
              const filterPaymentOrder = paymentOrders.filter((order) => paymentMethod.includes(order.category));
              const wallet = paymentOrders.filter((item) => item.category === 'WALLET');
              let newfilterPaymentOrder;
              if (value.account && paymentMethod.includes('WALLET')) {
                setPaymentTypeOrder(filterPaymentOrder);
              } if (value.account
                && (value.account.supportedPaymentTypes.includes('GOOGLE_PAY_US') || value.account.supportedPaymentTypes.includes('SWIREPAY_US'))
                && wallet && wallet.length > 0) {
                const googlePay = {
                  order: 4,
                  category: "WALLET",
                }
                filterPaymentOrder.push(googlePay);
                setPaymentTypeOrder(filterPaymentOrder);
                setPaymentTypeOrder(filterPaymentOrder);
              } else {
                newfilterPaymentOrder = filterPaymentOrder.filter(info => info.category !== 'WALLET');
                setPaymentTypeOrder(newfilterPaymentOrder);
              }
            } else {
              setSupportedPaymentTypes(value.account && value.account.supportedPaymentTypes);
            }
          }
        }
        if (value.account && value.account.portal) {
          const portal = value.account.portal.test;
          setIsTest(portal);
          supportedBankTypes(value.account.supportedPaymentTypes);
          if (portal) {
            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === true));
            setBanksList(supportedBanks);
          } else {
            const supportedBanks = NETBANKING_LIST.filter(data => (data.isTest === false));
            setBanksList(supportedBanks);
          }
        }
      }
    } catch (e) {
      props.history.push(`${pathname}/error`);
    }
  };

  const getQrPaymentById = async (paymentSession, psClientSecret, redirectionUri) => {
    try {
      const value = await getQrPaymentReconnection(paymentSession, psClientSecret);
      if (value) {
        const { nextActionUrl, status, receiptNumber } = value;
        const timeOut = redirectionUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (status === QR_STATUSES.SUCCEEDED) {
          if (!redirectionUri) {
            setTransactionSuccessModalOpen(true);
          }
          if (nextActionUrl) {
            window.location = nextActionUrl;
            return;
          }
          setTimeout(function () {
            const uri = getRedirectionUrl(hostName);
            const redirectUrl = redirectionUri ? redirectionUri : '';
            const urlPath = redirectUrl.includes("?");
            if (urlPath) {
              window.location = `${redirectUrl}&payment-page-link=${id}`;
            } else if (redirectUrl && !urlPath) {
              window.location = `${redirectUrl}?payment-page-link=${id}`;
            } else if (uri) {
              window.location = `${uri}receipts/${receiptNumber}`;
            }
          }, timeOut);
          if (id) { localStorage.removeItem(`${id}-tap-index`) }
        }
      }
    } catch (reason) {
      error(reason);
    }
  };

  const getPaymentPageLinkDataWithSearchValue = async () => {
    const params = new URLSearchParams(search);
    if (!(params.get('ps') || params.get('mp')) || !params.get('secret')) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setShowSpinner(true);
    try {
      const value = await findPaymentPageLinkById(id, search);
      if (value) {
        const { redirectUri } = value;
        const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
        if (!redirectUri) {
          setTransactionSuccessModalOpen(true);
        }
        setTimeout(function () {
          if (redirectUri) {
            window.location = redirectUri;
          } else props.history.push(`/payment-page-link/${id}`);
        }, timeOut);
        if (id) { localStorage.removeItem(id); }
      }
    } catch (reason) {
      getPaymentLinkDataWithoutSearchValue();
      error(reason);
    } finally {
      setShowSpinner(false)
    }
  };

  const error = reason => {
    setErrorMessage(null);
    if (!reason) return;
    const { data: { message, messageCode }, status } = reason;
    if (messageCode === 5102) {
      props.history.push(`${pathname}/error`);
      return;
    }
    setErrorMessage(message);
    if (status === 500) {
      setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
    }
    setTransactionModalOpen(false);
    const errorEl = document.getElementById("error");
    if (null !== errorEl) { errorEl.scrollIntoView(); }
  };

  const onApprove = async (data) => {
      try {
        await confirmWalletOrderInfo(orderDatas?.paymentSessionGid, orderDatas?.psClientSecret);
        setTransactionSuccessModalOpen(true);
        chargeByIdSuccessActions(orderDatas);
      } catch (error) {
        console.error(error);
        throw error;
      }
    };
  
    const createOrder = async (paypalData, actions) => {
      try {
        const values = await getServerEncription(commonRecaptchaToken?.current ?? null);
        if (values?.public_key) {
          const keys = generateClientKeyPair();
          if (keys?.privateKey) {
            let data = {};
            const customer = {
              email: paymentPageFields?.contactUsEmail ? paymentPageFields?.contactUsEmail : '',
              name: paymentPageFields?.name ? paymentPageFields?.name : '----',
              phoneNumber: paymentPageFields?.contactUsPhone ? paymentPageFields?.contactUsPhone : ''
            }
            if (!Array.isArray(payment?.paymentPageMeta?.paymentPageLinks) || !Array.isArray(paymentPageEntries)) throw new Error('Payment Page data missing');
            const paymentPageMetaGid = payment.paymentPageMeta.paymentPageLinks[0]?.paymentPageMetaGid;
            if (paypalData?.paymentSource === 'paypal') {
              data = {
                customerDetails: customer,
                paymentMethodDetails: {
                  payPalWallet: {
                    rawData: {
                      experience_context: {
                        payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                        landing_page: "LOGIN",
                        return_url: SWIREPAY_URL,
                        cancel_url: SWIREPAY_URL,
                      }
                    }
                  },
                  type: "WALLET",
                  subType: "PAYPAL_WALLET"
                },
                paymentPageMetaGid,
                paymentMethodType: ["WALLET"],
                paymentPageEntries,
              };
            } else if (paypalData?.paymentSource === 'venmo') {
              data = {
                customerDetails: customer,
                paymentMethodDetails: {
                  venmo: {
                    rawData: {
                      experience_context: {
                        payment_method_preference: "IMMEDIATE_PAYMENT_REQUIRED",
                        landing_page: "LOGIN",
                        return_url: SWIREPAY_URL,
                        cancel_url: SWIREPAY_URL,
                      }
                    }
                  },
                  type: "WALLET",
                  subType: "VENMO"
                },
                paymentPageMetaGid,
                paymentMethodType: ["WALLET"],
                paymentPageEntries,
              };
            }
            const encriptedData = encryptData(JSON.stringify(data), values.public_key, keys.privateKey, values.key_id);
            const payload = {
              publicKey: keys?.publicKey,
              keyId: encriptedData?.keyId,
              iv: encriptedData?.iv,
              data: encriptedData?.encryptedData,
            }
            if (encriptedData?.keyId) {
              const value = await paymentPageChargeById(id, payload);
              commonRecaptchaToken.current = null;
              if (value?.paymentSessionGid) {
                setOrderData(value)
                const orderData = await getWalletOrderInfo(value?.paymentSessionGid, value?.psClientSecret);
                if (!orderData.id) {
                  const errorDetail = orderData.details[0];
                  const errorMessage = errorDetail
                    ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                    : "Unexpected error occurred, please try again.";
  
                  throw new Error(errorMessage);
                }
                return orderData?.id;
              }
            }
          }
        }
      } catch (error) {
        if (error?.status === 429) {
          setSavedPaymentDetails(paypalData);
          setRecaptchaPaymentType('payPalButton');
          setRecaptchaModalVisible(true);
          setTransactionModalOpen(false);
          throw new Error('Recatpcha Required');
        }
        console.error(error);
        throw error || new Error('Unexpected error occurred, please try again.');
      }
    };

  const uniquePaymentTypes = paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
  if(uniquePaymentTypes.includes('WALLET')) {
    if (swirepayUS) {
        uniquePaymentTypes.push('SWIREPAY_US');
    }
    if (!googlePayUs) {
        const index = uniquePaymentTypes.indexOf('WALLET');
        if (index > -1) {
            uniquePaymentTypes.splice(index, 1);  // Removes the 'WALLET' from the array
        }
    }
}
  const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
    let children;
    let id;
    if (name === TabNames.ACH_LEGACY) {
      children = <AchPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={paymentPageChargeByACH}
        customerFields={paymentPageFields || paymentPageMeta}
        phoneInputReadOnly={paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone}
        paymentPagePay={true}
        customerEnabled={true}
        preFillCustomer={null}
        headerText={accountGid.includes(account?.gid) ? "Pay With BANK" : "Pay With ACH"}
        buttonText={submitBtnTextAch}
        customerValidation={true}
        showWhatsAppNotify={false}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={0}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayableAch}
        discount={discount}
        subTotal={subTotal}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        payments={account?.gid}
        plaidPublicToken={plaidPublicToken}
        setPlaidPublicToken={setPlaidPublicToken}
        accountGid={account?.gid}
        paymentLinkId={paramsId}
        clearZipCode={true}
        isTest={account?.portal?.test}
        enableConsentCheckbox={true}
        accountName={account?.name}
        paymentDate={dayjs().format('MMMM D, YYYY')}
        finalPayAmount={typeof submitBtnText === 'string' && submitBtnText.slice(4)}
      />
      id = name;
    } else if (name === TabNames.CARD) {
      children = <CardPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        submit={paymentPageChargeCard}
        customerFields={paymentPageFields || paymentPageMeta}
        phoneInputReadOnly={paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone}
        paymentPagePay={true}
        preFillCustomer={null}
        headerText={"Pay With Card"}
        buttonText={submitBtnText}
        isZipCodeRequired={(account && account.collectCustomerAddress)}
        isBillingAdressRequired={(account && account.collectBillingAddress)}
        showWhatsAppNotify={false}
        customerValidation={true}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
        validateAmount={totalPayable ? totalPayable / 100 : amount}
        payment={{amount: totalPayable && totalPayable, currency: currency && currency}}
        chargeByApplePay={chargeByApplePay}
        ApplePayment={applePayment}
        accountId={account && account.gid}
        payments={payment && payment}
        getCardNum={getCardNum}
        surchargeType={account?.surchargeType}
        updateSurcharge={updateSurcharge}
        surchargeEnabled={paymentPageMeta?.surchargeEnabled}
        clearZipCode={true}
      />
      id = name;
    } else if (name === TabNames.UPI) {
      children = <UpiPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        paymentPagePay={true}
        customerFields={paymentPageFields || paymentPageMeta}
        phoneInputReadOnly={paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone}
        paymentPageMeta={paymentPageMeta}
        account={account}
        paymentPageEntries={paymentPageEntries}
        submit={paymentPageChargeByUPI}
        preFillCustomer={null}
        showWhatsAppNotify={false}
        headerText={"Pay With UPI"}
        hideQr={false}
        buttonText={submitBtnText}
        customerValidation={true}
        getPaymentById={getQrPaymentReconnection}
        upiUrl={`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
        supportedPaymentTypes={account && account.supportedPaymentTypes}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkUpiGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkUpiGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
        showMobileViewUpi={true}
        onReturnFromUpiApp={onReturnFromUpiApp}
        onChargeByUpiIndent={chargeByUpiIndent}
        showIndentCustomer={true}
      />
      id = name;
    } else if (name === TabNames.ACH) {
      children = <BankPayment
        errorMsg={errorMessage}
        errorHeader={null}
        customerDisabled={false}
        phoneInputReadOnly={paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone}
        submit={paymentPageChargeByBANK}
        headerText={"Pay With Bank Transfer"}
        buttonText={submitBtnText}
        paymentLinkId={id}
        showWhatsAppNotify={false}
        iavUrl={`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`}
        customerValidation={true}
        requiredPhone={true}
        paymentPageGId={account && account.gid}
        publicKey={account && account.usPublicKey}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
      />
      id = name;
    } else if (name === TabNames.NET_BANKING) {
      children = <NetBanking
        errorMsg={errorMessage}
        errorHeader={null}
        customerReadOnly={false}
        customerFields={paymentPageFields || paymentPageMeta}
        phoneInputReadOnly={paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone}
        submit={chargeByNetBanking}
        headerText={"PAY WITH NET BANKING"}
        cancelButtonText={"Decline"}
        buttonText={submitBtnText}
        customerValidation={true}
        banksList={banksList}
        bankTypes={bankTypes}
        isTest={isTest || true}
        showWhatsAppNotify={false}
        paymentPage={true}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
      />
      id = name;
    } else if (name === TabNames.GOOGLE_PAY_US) {
      children = <>
        {
          payPalClientAuth ? (
            <PayPalGooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={{ amount: totalPayable && totalPayable, currency: account.currency }}
              chargeByGooglePay={chargeByPaypalGooglePay}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
              accountGid={account?.gid}
              setTransactionModalOpen={setTransactionModalOpen}
              paypalGooglePayRecaptchaToken={paypalGooglePayRecaptchaToken}
            />
          ) : (
            <GooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={{ amount: totalPayable && totalPayable, currency: account.currency }}
              chargeByGooglePay={chargeByGooglePay}
              errorMsg={errorMessage}
              gpaySecretValues={gpaySecretValues}
              gpayError={gpayError}
              errorHeader={null}
            />
          )
        }
      </>
      id = name;
  } else if (name === TabNames.WALLET) {
      children = <>
        {
          payPalClientAuth ? (
            <PayPalGooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={{ amount: totalPayable && totalPayable, currency: account.currency }}
              chargeByGooglePay={chargeByPaypalGooglePay}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
              accountGid={account?.gid}
              setTransactionModalOpen={setTransactionModalOpen}
              paypalGooglePayRecaptchaToken={paypalGooglePayRecaptchaToken}
            />
          ) : (
            <GooglePay
              headerText={"PAY WITH GOOGLE PAY"}
              payment={{ amount: totalPayable && totalPayable, currency: account.currency }}
              chargeByGooglePay={chargeByGooglePay}
              gpaySecretValues={gpaySecretValues}
              gpayError={gpayError}
              errorMsg={errorMessage}
              errorHeader={null}
            />
          )
        }
      </>
      id = name;
  } else if (name === TabNames.APPLE_PAY_US) {
      children = <>
        {
          payPalClientAuth ? (
            <ApplePayButton
              recaptchaToken={paypalApplePayRecaptcha}
              amount={totalPayable && totalPayable}
              chargeByApple={chargeByApplePay}
              payment={{ amount: totalPayable && totalPayable, currency: currency && currency }}
              accountGid={account?.gid}
              successCallback={chargeByIdSuccessActions}
              failCallback={chargeByIdFailActions}
            />
          ) : (
            <ApplePay
              headerText={"PAY WITH APPLE PAY"}
              payment={{ amount: totalPayable && totalPayable, currency: currency && currency }}
              chargeByApplePay={chargeByApplePay}
              gpayError={null}
              errorMsg={errorMessage}
              errorHeader={null}
            />
          )
        }
      </>
      id = name;
  } else if (name === TabNames.INSTANT_PAYMENT) {
      children = <InstantPayment
        errorHeader={null}
        customerReadOnly={false}
        errorMsg={errorMessage}
        customerFields={paymentPageFields || paymentPageMeta}
        phoneInputReadOnly={paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone}
        submit={chargeByInstantPay}
        customerDisabled={true}
        headerText={null}
        buttonText={submitBtnText}
        showCustomer={true}
        customerValidation={true}
        paymentPage={true}
        showWhatsAppNotify={false}
        hideQr={true}
        upiUrl={`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else if (name === TabNames.SWIREPAY_US) {
      children = <InstantPayment
        errorHeader={null}
        customerReadOnly={false}
        errorMsg={errorMessage}
        customerFields={paymentPageFields || paymentPageMeta}
        phoneInputReadOnly={paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone}
        submit={chargeBySwirepayUS}
        customerDisabled={true}
        headerText={null}
        buttonText={submitBtnText}
        customerValidation={true}
        paymentPagePay={true}
        showWhatsAppNotify={false}
        hideQr={false}
        upiUrl={`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`}
        getPaymentById={getQrPaymentById}
        tip={finalTip}
        surcharge={surcharge}
        serviceFee={serviceFee}
        serviceFeeRate={serviceFeeRate}
        serviceFeeRateVal={serviceFeeRateVal}
        amount={net}
        serviceFeeVal={feeService}
        alpha2={currency && currency.countryAlpha2}
        prefix={currency && currency.prefix}
        paymentMethodDetails={true}
        paymentMethodType={true}
        tax={finalTax}
        totalPayable={totalPayable}
        discount={discount}
        subTotal={subTotal}
        swirepayUS={swirepayUS}
        metaGid={paymentPageMeta.gid}
        metaPageEntries={paymentPageEntries}
        setRecaptchaModalVisible={setRecaptchaModalVisible}
        setSavedPaymentDetails={setSavedPaymentDetails}
        savedPaymentDetails={savedPaymentDetails}
        globalRecaptchaToken={paymentLinkInstantPaymentGlobalRecaptcha}
        setGlobalRecaptchaToken={setPaymentLinkInstantPaymentGlobalRecaptcha}
        setRecaptchaPaymentType={setRecaptchaPaymentType}
      />
      id = name;
    } else {
      children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
    }
    panel.push({ children, id });
    return panel;
  }, []) : [{
    children: <CardPayment
      errorMsg={errorMessage}
      errorHeader={null}
      customerReadOnly={false}
      submit={paymentPageChargeCard}
      preFillCustomer={null}
      customerFields={paymentPageMeta}
      phoneInputReadOnly={paymentPageFields?.promoCode && paymentPageFields?.contactUsPhone}
      paymentPagePay={false}
      headerText={"Pay With Card"}
      buttonText={submitBtnText}
      isZipCodeRequired={(account && account.collectCustomerAddress)}
      isBillingAdressRequired={(account && account.collectBillingAddress)}
      customerValidation={true}
      showWhatsAppNotify={false}
      tip={finalTip}
      surcharge={surcharge}
      serviceFee={serviceFee}
      serviceFeeRate={serviceFeeRate}
      serviceFeeRateVal={serviceFeeRateVal}
      amount={net}
      serviceFeeVal={feeService}
      alpha2={currency && currency.countryAlpha2}
      prefix={currency && currency.prefix}
      tax={finalTax}
      totalPayable={totalPayable}
      discount={discount}
      subTotal={subTotal}
      payment={{amount: totalPayable && totalPayable, currency: currency && currency}}
      chargeByApplePay={chargeByApplePay}
      ApplePayment={applePayment}
      accountId={account && account.gid}
      payments={payment && payment}
      getCardNum={getCardNum}
      surchargeType={account?.surchargeType}
      updateSurcharge={updateSurcharge}
      surchargeEnabled={paymentPageMeta?.surchargeEnabled}
    />,
    id: 'CARD'
  }];
  const tabPanelsApple =

           {// children :  <Apple amount={totalPayable} accountName={account && account.name} chargeByApple={chargeByApple} payment={paymentPageMeta}/>
              children : <>
                {
                    payPalClientAuth ? (
                        <ApplePayButton
                            recaptchaToken={paypalApplePayRecaptcha}
                            amount={totalPayable && totalPayable}
                            chargeByApple={chargeByApple}
                            payment={paymentPageMeta}
                            accountGid={account?.gid}
                            successCallback={chargeByIdSuccessActions}
                            failCallback={chargeByIdFailActions}
                        />
                    ) : (
                        <>
                        {
                            applePayment && isApplePay ? <Apple amount={totalPayable && totalPayable}  accountName={account && account.name} chargeByApple={chargeByCardpointeApplePay} payment={paymentPageMeta}/>:null
                        }
                        </>
                    )
                }
            </>,
              id:  applePayment && isApplePay ? 'APPLE_PAY_US' : null
            }
    ;

    tabPanels.push(tabPanelsApple);

    if (account?.country?.alpha2 === 'US') {
      tabPanels.push({
        children: <SavedPaymentMethods
                    buttonText={submitBtnText}
                    submit={chargeBySavedPaymentMethods}
                    supportedPaymentTypes={uniquePaymentTypes}
                  />,
        id: 'SAVED_PAYMENT_METHODS'
      });
    }

    if (payPalClientAuth && payPalClientId) {
      tabPanels.push({
        children: <div style={{ width: '200px'}} >
        <PayPalCheckout
          styles={{ shape: "rect", layout: "vertical" }}
          createOrder={createOrder}
          onApprove={onApprove}
          payPalClientId={payPalClientId}
          currency={account?.currency?.name || 'USD'}
          country={account?.country?.alpha2 || 'US'}
        />
        </div>,
        id: 'PAYPAL_METHOD',
      });
      uniquePaymentTypes.push('PAYPAL_METHOD');
    }

 /* const tabPanelsApple =

           { //children :  <Apple amount={AmountDivideByHundred(payment && payment.amount)} chargeByApple={chargeByApple} payment={payment}/>
              children : applePayment&&isApplePay ? <Apple amount={totalPayable} chargeByApple={chargeByApple} payment={paymentPageMeta}/>:null
            }
    ;

    tabPanels.push(tabPanelsApple);*/

  useEffect(() => {
    setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
  }, [selectedTab, uniquePaymentTypes]);

  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  const customPrimaryHeadingProps = {
    fontWeight: 'bold',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '20px',
  };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <BaseSplitPage
    errorHeader={null}
    errorMsg={errorMessage}
    left={
      <>
        <FlexContainer
          flexDirection="column"
          position="relative"
          display="block"
          height="100%"
        >
          <div>
            <LeftBackButtonText
              onClick={() => { props.history.push(`/payment-page-link/${id}`); }}
            >
              Back
            </LeftBackButtonText>
            <H1Text>
              Payment Checkout
            </H1Text>
            <H2Text>
              Payment For
            </H2Text>
            <DescriptionText>
              {paymentPageMeta && paymentPageMeta.title}
            </DescriptionText>
            {/*<H2Text>
              Amount Payable
            </H2Text>
            <DescriptionText fontSize="24px">
            {currency && currency.prefix} {totalPayable ? AmountDivideByHundred(totalPayable) : '0.00'}
            </DescriptionText>*/}
          </div>
          <div style={{ position: "sticky", top: "85%" }}>
            <Support email={paymentPageMeta && paymentPageMeta.contactUsEmail}
              whiteLabel={account && account.whiteLabel}
              phone={paymentPageMeta && paymentPageMeta.contactUsPhone} />
          </div>
        </FlexContainer>
      </>
    } right={
      <>
        <SmallScreenHeader cancelUrlLink={`/payment-page-link/${id}`}>
          <FlexContainer {...customContainerProps}>
            <H1Text {...customPrimaryHeadingProps}>
              Payment Checkout
            </H1Text>
            <Hr/>
            <FlexContainer {...customFlexContainerProps}>
              <H2Text {...customSecondaryHeadingProps}>
                Payment For
              </H2Text>
              <DescriptionText {...customDescriptionProps}>
                {paymentPageMeta && paymentPageMeta.title}
              </DescriptionText>
            </FlexContainer>
          </FlexContainer>
        </SmallScreenHeader>
        {account?.country?.alpha2 === 'US' ? (
          <PaymentExpandableRowsV2
            id={id}
            paymentTypes={(account && account.currency && account.currency.countryAlpha2)}
            tabs={uniquePaymentTypes}
            tabPanels={tabPanels}
            defaultSelectedTab={selectedTab || 0}
            onSelect={data => setSelectedTab(data)}
            tabName={tabName}
            upiDown={upiDownTime}
            applePayment={applePayment}
            isApplePay ={isApplePay}
            accountGid={account?.gid}
            getCurrentTab={getCurrentTab}
          />
          ) : (
          <PaymentExpandableRows
            id={id}
            paymentTypes={(account && account.currency && account.currency.countryAlpha2)}
            tabs={uniquePaymentTypes}
            tabPanels={tabPanels}
            defaultSelectedTab={selectedTab || 0}
            onSelect={data => setSelectedTab(data)}
            tabName={tabName}
            upiDown={upiDownTime}
            applePayment={applePayment}
            isApplePay ={isApplePay}
            accountGid={account?.gid}
            getCurrentTab={getCurrentTab}
          />
        )}
        <RecaptchaModal
          visible={recaptchaModalVisible}
          onVerified={onGlobalCaptchaVerified}
        />
        <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
        <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} accountId={account?.gid} paymentId={id} manualPlaidPayment={manualPlaidPayment} />
        <Spinner isOpen={isShowSpinner} />
        <DataAlertModal isOpen={isDataAlertModalOpen} header={"We lost your data"} body={"You will be redirect"} />
      </>
    } />
  )
};

export default PaymentPagePay;